import axios from 'axios';

export default ({ Vue }) => {
  Vue.prototype.$axios = axios;
};



// WEBPACK FOOTER //
// ./src/plugins/axios.js